export const extractNormalizedEmails = (value: string) => {
  const matches =
    value.match(/[A-Z0-9._%+-]+\s*@\s*[A-Z0-9.-]+\s*\.\s*[A-Z]{2,}/gi) || [];

  return Array.from(
    new Set(matches.map((email) => email.replace(/\s+/g, "").trim().toLowerCase()))
  );
};

export const ACTION_LABELS: Record<string, string> = {
  created: "Sukurta nauja paskyra",
  "products-added": "Produktai pridėti esamai paskyrai",
  unchanged: "Nieko keisti nereikėjo",
  failed: "Nepavyko apdoroti",
};

export const sanitizeName = (value: string) => value.replace(/[^A-Za-zÀ-ž\s]/g, "");

export const downloadPdfBlob = (pdfBlob: Blob | null, filename = "certificate.pdf") => {
  if (!pdfBlob) {
    return;
  }

  const url = URL.createObjectURL(pdfBlob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
};
